<template>
  <div class="pessoas-redefinir-senha-container">
    <v-btn icon absolute top left @click="$router.go(-1)" class="tertiary ml-1">
      <v-icon color="white">mdi-arrow-left</v-icon>
    </v-btn>
    <v-card class="pessoas-redefinir-senha-container1" elevation="8">
      <div class="pessoas-redefinir-senha-header mt-3">
        <span>
          <v-icon color="tertiary" size="30" class="mr-2">
            mdi-key-variant
          </v-icon>
        </span>
        <h1>Redefinir Senha</h1>
      </div>
      <v-form
        @submit.prevent="handleSubmit"
        class="pessoas-redefinir-senha-form"
      >
        <v-row class="mt-12 mb-4">
          <BaseTextField
            required
            label="Senha atual"
            id="senha"
            name="senha"
            placeholder="******"
            v-model="$pessoas_usuarios.user.old_password"
            :type="$pessoas_usuarios.user.show_old_pass ? 'text' : 'password'"
            :append-icon="
              $pessoas_usuarios.user.show_old_pass
                ? $config.icons.viewOff
                : $config.icons.view
            "
            @click:append="
              $pessoas_usuarios.user.show_old_pass =
                !$pessoas_usuarios.user.show_old_pass
            "
            tabindex="1"
            autocomplete="off"
          ></BaseTextField>
        </v-row>
        <v-row class="mb-4">
          <BaseTextField
            label="Nova senha"
            required
            id="senha2"
            name="senha2"
            placeholder="******"
            v-model="$pessoas_usuarios.user.senha"
            :type="$pessoas_usuarios.user.show_senha ? 'text' : 'password'"
            :append-icon="
              $pessoas_usuarios.user.show_senha
                ? $config.icons.viewOff
                : $config.icons.view
            "
            @click:append="
              $pessoas_usuarios.user.show_senha =
                !$pessoas_usuarios.user.show_senha
            "
            tabindex="2"
            autocomplete="off"
          ></BaseTextField>

          <PasswordRequirements :password="$pessoas_usuarios.user.senha" />
        </v-row>
        <v-row class="mb-4">
          <BaseTextField
            label="Confirmar nova senha"
            required
            id="senha3"
            name="senha3"
            placeholder="******"
            v-model="$pessoas_usuarios.user.senha2"
            :type="$pessoas_usuarios.user.show_senha2 ? 'text' : 'password'"
            :append-icon="
              $pessoas_usuarios.user.show_senha2
                ? $config.icons.viewOff
                : $config.icons.view
            "
            @click:append="
              $pessoas_usuarios.user.show_senha2 =
                !$pessoas_usuarios.user.show_senha2
            "
            tabindex="3"
            autocomplete="off"
          ></BaseTextField>
        </v-row>
        <v-row>
          <v-btn
            height="45"
            class="button button-bg rounded-lg"
            block
            tabindex="4"
            type="submit"
          >
            <span>Alterar senha</span>
          </v-btn>
        </v-row>
      </v-form>
    </v-card>
    <waves :lower-text="true" />
  </div>
</template>

<script>
import waves from "@/components/global/waves.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import { mapGetters, mapActions } from "vuex";
import PasswordRequirements from "../../components/forms/PasswordRequirements.vue";
import { i18n } from "../../main";
import {
  validatePasswordMinCharacters,
  validatePasswordMinLowerCase,
  validatePasswordMinNumbers,
  validatePasswordMinSpecialCharacters,
  validatePasswordMinUpperCase,
} from "../../utils/index";
export default {
  name: "RedefinePass",
  components: {
    waves,
    BaseTextField,
    PasswordRequirements,
  },
  metaInfo: {
    title: "Redefinir Senha | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Redefinir Senha | ElevenTickets",
      },
    ],
  },
  data() {
    return {
      redefinirSenha: {
        senhaAntiga: "",
        senhaNova: "",
        senhaNovaConfirm: "",
        showPass1: false,
        showPass2: false,
        showPass3: false,
      },
    };
  },
  computed: {
    ...mapGetters(["isAdmin", "userInfo"]),
  },
  methods: {
    ...mapActions(["changePasswordAffiliate", "showSnackbarError"]),
    handleSubmit() {
      if (this.isAdmin) {
        this.$pessoas_usuarios.trocarSenha(this.redefinirSenha);
      } else {
        if (this.$pessoas_usuarios.user.old_password.length == 0) {
          this.showSnackbarError("Insira sua senha atual");
          this.$pessoas_usuarios.user.error.old_password =
            "Insira sua senha atual";
          return;
        }
        if (this.$pessoas_usuarios.user.senha.length == 0) {
          this.showSnackbarError("Insira sua nova senha");
          this.$pessoas_usuarios.user.error.senha = "Insira sua nova senha";
          return;
        }

        const password = this.$pessoas_usuarios.user.senha;

        if (validatePasswordMinCharacters(password)) {
          this.showSnackbarError(
            i18n.t("common.password-requirements.error-messages.min-length")
          );
          return;
        }

        if (validatePasswordMinNumbers(password)) {
          this.showSnackbarError(
            i18n.t("common.password-requirements.error-messages.min-numbers")
          );
          return;
        }

        if (validatePasswordMinLowerCase(password)) {
          this.showSnackbarError(
            i18n.t(
              "common.password-requirements.error-messages.min-non-capital-characters"
            )
          );
          return;
        }

        if (validatePasswordMinUpperCase(password)) {
          this.showSnackbarError(
            i18n.t(
              "common.password-requirements.error-messages.min-capital-characters"
            )
          );
          return;
        }

        if (validatePasswordMinSpecialCharacters(password)) {
          this.showSnackbarError(
            i18n.t(
              "common.password-requirements.error-messages.min-special-characters"
            )
          );
          return;
        }

        if (
          this.$pessoas_usuarios.user.senha !=
          this.$pessoas_usuarios.user.senha2
        ) {
          this.showSnackbarError("As senhas são incompatíveis!");
          this.$pessoas_usuarios.user.error.senha2 =
            "As senhas são incompatíveis!";
          return;
        }
        this.changePasswordAffiliate({
          id: this.userInfo.idafiliado,
          oldPass: this.$pessoas_usuarios.user.old_password,
          newPass: this.$pessoas_usuarios.user.senha,
        });
      }
    },
  },
  mounted() {
    if (!this.$axios.getLocal("oe_user_info")) {
      this.$axios.rota("login");
    }
    this.$pessoas_usuarios.user.old_password = "";
    this.$pessoas_usuarios.user.senha = "";
    this.$pessoas_usuarios.user.senha2 = "";
    this.$pessoas_usuarios.user.show_old_pass = false;
    this.$pessoas_usuarios.user.show_senha = false;
    this.$pessoas_usuarios.user.show_senha2 = false;
  },
};
</script>

<style scoped>
.pessoas-redefinir-senha-container {
  width: 100%;
  display: flex;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.pessoas-redefinir-senha-container1 {
  width: 550px;
  height: auto;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  z-index: 3;
}

.pessoas-redefinir-senha-header {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pessoas-redefinir-senha-form {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0.625rem;
}

.back-button {
  position: absolute;
  top: 0;
  left: 0;
}
</style>
